/**
 * Polska odmiana rzeczownika po liczebniku (1 / 2–4 / 5+).
 *
 * Powstało po teście akceptacyjnym 2026-08-05: reguła była już zaimplementowana w
 * `PipelineView.budynkiLabel`, ale sąsiednie napisy jej NIE używały i wychodziło
 * „1 budynków" / „(1 lokali)" — także na PDF-ie dla klienta. Jedno miejsce na regułę
 * zamiast kopii przy każdym liczniku.
 *
 * Formy podaje się w kolejności: [mianownik lp., 2–4, 5+], np.
 * `['budynek', 'budynki', 'budynków']`, `['lokal', 'lokale', 'lokali']`.
 */
export function pluralPl(n: number, forms: [string, string, string]): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (n === 1) return forms[0];
  // 12–14 to wyjątek: „12 budynków", nie „12 budynki".
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1];
  return forms[2];
}

/** „1 budynek" / „3 budynki" / „27 budynków". */
export function budynkiLabel(n: number): string {
  return `${n} ${pluralPl(n, ['budynek', 'budynki', 'budynków'])}`;
}

/** „1 lokal" / „3 lokale" / „7 lokali". */
export function lokaleLabel(n: number): string {
  return `${n} ${pluralPl(n, ['lokal', 'lokale', 'lokali'])}`;
}

/**
 * „zrobione 22 z 27 lokali" — kolumna „Gotowość terenowa" w Budynkach (B7, Bronek: „22/27 lokale"
 * czytało się jak liczba lokali budynku). Po „z" dopełniacz: „z 1 lokalu", „z 2 / 5 / 22 lokali".
 */
export function doneOfApartmentsLabel(done: number, total: number): string {
  if (total <= 0) return 'brak lokali';
  return `zrobione ${done} z ${total} ${total === 1 ? 'lokalu' : 'lokali'}`;
}
